import React, { useState } from "react";
import { User } from "../../http/protocol";


export interface UserActionContainerProps extends React.HTMLProps<HTMLDivElement> {
    title?: string;
    error?: string;
    users?: UserAction[];
    updateUser?: (user: any) => void;
    updateUsers?: (users: any[]) => void;
    setConfirmModal?: (c: any) => void;
}
export enum UpdateAllAction {
    SUBMIT = "submit",
    STOP = "stop",
    RESET = "reset",
    REMOVE = "remove"
}

export enum UpdateActionStatus {
    ADDED = "ADDED",
    PENDING = "PENDING",
    OK = "OK",
    FAIL = "FAIL",
    DENIED = "DENIED"
}
export interface UserAction {
    id: number;
    email: string;
    user: User;
    status?: UpdateActionStatus;
    description?: string;
    request?: () => Promise<{ status: UpdateActionStatus; description: string; response: any; }>;
    response?: any;
}

export const UserActionContainer: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {
    const [lookupExpanded, setLookupExpanded] = useState(true);

    return (
        <div className={"card-box expandable-box"} style={!lookupExpanded ? { cursor: "pointer" } : { cursor: "default" }} onClick={() => !lookupExpanded ? setLookupExpanded(true) : null}>
            {lookupExpanded && (
                <a href="/#" className="expand-button float-right" onClick={(e: any) => { e.preventDefault(); setLookupExpanded(false); }}><i className="mdi mdi-minus"></i></a>
            )}
            {!lookupExpanded && (
                <a href="/#" className="expand-button float-right" onClick={(e: any) => { e.preventDefault(); setLookupExpanded(true); }}><i className="mdi mdi-plus"></i></a>
            )}
            <div className="" onClick={() => setLookupExpanded(!lookupExpanded)}>
                <h4>{props.title || "User Action"}</h4>
            </div>
            <div className="hr-line-dashed"></div>
            {props.error && (<>Error: {props.error}</>)}
            {!props.error && lookupExpanded && (<>
                {props.children && props.children}
                {!props.children && (<>Missing Children</>)}
            </>)}
        </div>
    );
};
